module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAB3slV3slV3slV3slV3slV3slV3slW72ar3+vT///+At2Dm8d9uVASEAAAAB3RSTlMAYL8AIM/vi50ITwAAAQdJREFUeNrt2EkKwzAQRFF5lKf7nzd2svgBQQW6mqxU6+4H0sLCVZ4MYzUyDtOdMk3zUs0s8wPNa7Wzzje01IQsUxlqSoYy5kBjqUnpUIc69J1tP459O13ovI53LgPCebIBWc6xA4UcAmQ4BoRjHg2nvWzLuU4g0wEyHSDTATIdINMBMh0g2wHyHSDfAeKrF3CAmGZMOBLaGPzlaGhvRoWjoGZYOxpiXDv6aO2CdvRlsyIcDdVmSTgKateEo6BWEo6CWkk4AkIKOEBIMQcIKeAASQlHQ0LCiUBIOBEICScCIeFEICScEISEE4KQPk9K/xfp0H+htJIlrfbJKqLSqrHMsu5ORn34Am2+l0WN6H2UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2705.png
// module id = 1387
// module chunks = 0